import { Component, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '@partners/ui';

@Component({
  selector: 'info-icon',
  standalone: true,
  imports: [IconComponent],
  template: `
    <icon iconName="ico-rounded--doc-alert" iconVariant="rounded" iconSize="lg" />
    
  `,
  styles: ``,
  encapsulation: ViewEncapsulation.None
})
export class InfoIconComponent {}
